// src/routes/routesConfig.js
import Home from "../Home";
import Cartpage from "../Cartpage";
import Checkout from "../component/Checkout";
import GetinTouch from "../component/GetinTouch";
import Course from "../component/Course";
import About from "../component/About";
import Blogdetail from "../component/Blogdetail";
import Blog from "../component/Blog";
import Coursedetail from "../component/Coursedetail";
import Instracter from "../component/Instracter-detail";
import Our_Instructors from "../component/Our_Instructors";
import Placmant from "../component/Placmant";
import NotFound from "../component/NotFound";
import Profail from "../component/Profail";
import PlaceOrderSuccess from "../component/Placeorder";
import PrivateRoute from "../component/privateRoute/PrivateRoute";
import Login from "../component/Login/Login";
import Start_course from "../component/Start_course/Startr_course";

export const publicRoutes = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <GetinTouch /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blogdetail/:slug", element: <Blogdetail /> },
  { path: "/course", element: <Course /> },
  { path: "/course-detail/:id", element: <Coursedetail /> },
  { path: "/ourinstructer", element: <Our_Instructors /> },
  { path: "/placmant", element: <Placmant /> },
  { path: "/team-detail/:slug", element: <Instracter /> },
  { path: "/placeorder", element: <PlaceOrderSuccess /> },
  { path: "/login", element: <Login /> },
  { path: "*", element: <NotFound /> },
];

// ✅ Private routes wrapped inside <PrivateRoute>
export const privateRoutes = [
  {
    path: "/cartpage",
    element: <PrivateRoute><Cartpage /></PrivateRoute>,
  },
  {
    path: "/checkout",
    element: <PrivateRoute><Checkout /></PrivateRoute>,
  },
  {
    path: "/profail",
    element: <PrivateRoute><Profail /></PrivateRoute>,
  },
  {
    path: "/courses/:slug",
    element: <PrivateRoute><Start_course /></PrivateRoute>,
  },
];
